module.exports = __webpack_public_path__ + "imgcvh/hero-4.2c686837.jpg";